import { API_ROOT_URL } from '../config';

export const PatientService = {
	fetchPatients,
};

function fetchPatients(id) {
	const token = JSON.parse(localStorage.getItem('token'));
	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
	};
	return fetch(`${API_ROOT_URL}/administrator/patient/${id}/`, requestOptions).then((response) => response.json());
}


// WEBPACK FOOTER //
// ./src/services/patient.services.js